import Splide from '@splidejs/splide';

const gk_cptBlock = {
  load() {
    const sliderBlocks = document.querySelectorAll('.CPTBlock.splide');

    sliderBlocks.forEach((el) => {
      if (el._splide) return;

      const slideCount = el.querySelectorAll('.splide__slide').length;
      if (slideCount < 2) return;

      const reveal     = el.dataset.reveal || 'fade';
      const speed      = parseInt(el.dataset.speed, 10) || 750;
      const autoplay   = el.dataset.autoplay === '1';
      const interval   = parseInt(el.dataset.autoplayInterval, 10) || 5000;
      const rewind     = el.dataset.rewind === '1';
      const showArrows = el.dataset.arrowsPosition !== 'hidden';
      const showDots   = el.dataset.dotsPosition !== 'hidden';

      const perPageXl  = parseInt(el.dataset.perPageXl,  10) || 3;
      const perPageLg  = parseInt(el.dataset.perPageLg,  10) || 3;
      const perPageMd  = parseInt(el.dataset.perPageMd,  10) || 2;
      const perPageSm  = parseInt(el.dataset.perPageSm,  10) || 2;
      const perPageXsl = parseInt(el.dataset.perPageXsl, 10) || 1;
      const perPageXs  = parseInt(el.dataset.perPageXs,  10) || 1;
      const safeXl     = Math.min(perPageXl, slideCount);

      const allOne = safeXl === 1 && perPageLg === 1 && perPageMd === 1 &&
                     perPageSm === 1 && perPageXsl === 1 && perPageXs === 1;
      const type   = (allOne && (reveal === 'fade' || reveal === 'clip-reveal'))
                       ? 'fade' : 'slide';

      const splide = new Splide(el, {
        type,
        perPage:    safeXl,
        speed,
        rewind,
        autoplay,
        interval,
        arrows:     showArrows,
        pagination: showDots,
        gap:        'var(--cpt-gap, 20px)',
        easing:     'cubic-bezier(0.76, 0, 0.24, 1)',
        keyboard:   'global',
        lazyLoad:   'nearby',
        breakpoints: {
          1199: { perPage: Math.min(perPageLg,  slideCount) },
          1023: { perPage: Math.min(perPageMd,  slideCount) },
           990: { perPage: Math.min(perPageSm,  slideCount) },
           767: { perPage: Math.min(perPageXsl, slideCount) },
           399: { perPage: Math.min(perPageXs,  slideCount) },
        },
        i18n: {
          prev:   'Slide précédente',
          next:   'Slide suivante',
          first:  'Première slide',
          last:   'Dernière slide',
          slideX: 'Slide %s',
          pageX:  'Page %s',
        },
      });

      if (reveal === 'zoom' || reveal === 'clip-reveal') {
        splide.on('move', (newIdx) => {
          const slidesEls = el.querySelectorAll('.splide__slide');
          const next = slidesEls[newIdx];
          if (!next) return;
          next.classList.add('is-revealing');
          setTimeout(() => next.classList.remove('is-revealing'), 800);
        });
      }

      splide.mount();
      el._splide = splide;
    });
  },
};

export default gk_cptBlock;
